import React from "react";
import { useState, useEffect } from "react";
import MovieCard from "./MovieCard";

import './App.css';
import SearchIcon from './search.svg';
//a21c9c41
const API_URL = 'https://www.omdbapi.com/?apikey=a21c9c41';

const movie1 = {
    "Title": "Avengers: Endgame",
    "Year": "2019",
    "imdbID": "tt4154796",
    "Type": "movie",
    "Poster": "https://m.media-amazon.com/images/M/MV5BMTc5MDE2ODcwNV5BMl5BanBnXkFtZTgwMzI2NzQ2NzM@._V1_SX300.jpg"
}

const App = () => {

    const [movies, setMovies] = useState([]);
    const [searchValue, setSearchValue] = useState('');


    const searchMovies = async (title) => {
        const res = await fetch(`${API_URL}&s=${title}`);
        const data = await res.json();
        setMovies(data.Search);  
    };

    useEffect(() => {
        searchMovies('Avengers');
    } , []);
    return (
        <div className="app">
            <h1 className="title">MOVIE FANTASY</h1>
            <div className="search">
                <input type="text" className="search-input" value={searchValue} onChange={(e) => setSearchValue(e.target.value)} placeholder="Search for a movie" />
                <img src={SearchIcon} alt="Search Icon" className="search-icon" onClick={() => searchMovies(searchValue)} />
                </div>

            {
            movies?.length > 0 ?
            (
            <div className="container">
                {movies.map((movie) => (
                <MovieCard  movie={movie} />
                ))}
            </div>
            ) : 
            (
            <div className="empty">
                <h2>No movies found</h2>
            </div>
            )}
                

        </div>
    );
}


export default App;